export default function Hero() {
  return (
    <section
      id="inicio"
      className="relative min-h-[620px] md:min-h-[760px] flex items-center overflow-hidden"
    >
      {/* Background Video */}
      <div className="absolute inset-0">
        <video
          src="https://public.readdy.ai/ai/video_res/01a06057-2334-7052-9ef2-50eca94703f7.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-foreground-950/20" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-36 pb-16 md:pb-24">
        <div className="max-w-4xl">
          {/* Urgency Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-400/30 backdrop-blur-sm mb-6 animate-fade-in">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-accent-500" />
            </span>
            <span className="text-accent-300 text-sm font-semibold">
              ¡Agenda tu diagnóstico!
            </span>
          </div>

          {/* Headline - Loss Aversion Hook */}
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            Climatización eficiente para{" "}
            <span className="text-accent-400">micro y macro proyectos</span>
          </h1>

          {/* Subheadline */}
          <p className="text-base md:text-lg lg:text-xl text-background-200 max-w-2xl mb-4 leading-relaxed">
            Climatiza tu espacio hoy con ingenieros profesionales. Más de{" "}
            <strong className="text-background-50">35 años de experiencia</strong>,{" "}
            <strong className="text-background-50">1,200+ proyectos</strong> y garantía
            real en cada instalación.
          </p>

          {/* Marcas registradas */}
          <p className="text-sm md:text-base text-background-300 max-w-2xl mb-4 leading-relaxed">
            <strong className="text-background-50">"Serin"</strong> y{" "}
            <strong className="text-background-50">"Organización Serin"</strong> son marcas
            registradas de SERIN Ingeniería de Proyectos S.A.S.
          </p>

          {/* Trust Micro-bar */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-background-300 text-sm mb-8">
            <span className="flex items-center gap-1.5">
              <i className="ri-star-fill text-accent-400 w-4 h-4 flex items-center justify-center" /> 4.9/5 clientes
            </span>
            <span className="hidden sm:inline text-background-400">|</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-verified-badge-line text-accent-300 w-4 h-4 flex items-center justify-center" /> Garantía 1 año
            </span>
            <span className="hidden sm:inline text-background-400">|</span>
            <span className="flex items-center gap-1.5">
              <i className="ri-time-line text-accent-300 w-4 h-4 flex items-center justify-center" /> Respuesta en 2 horas
            </span>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="https://wa.link/0adpkz"
              className="px-7 py-3.5 rounded-lg bg-accent-500 text-background-50 font-semibold text-base hover:bg-accent-600 transition-colors shadow-lg shadow-accent-500/20 text-center whitespace-nowrap"
            >
              <i className="ri-calendar-check-line mr-2" />
              SOLICITAR ASESORÍA GRATUITA
            </a>
            <a
              href="https://wa.link/b002hg"
              className="px-7 py-3.5 rounded-lg bg-white/10 text-background-50 font-semibold text-base border border-white/20 hover:bg-white/20 transition-colors text-center whitespace-nowrap"
            >
              Ver servicios
            </a>
          </div>

          {/* Bottom micro-trust */}
          <p className="mt-4 text-background-400 text-xs md:text-sm">
            Sin compromiso. Sin costo oculto. Atención en Bogotá y toda Colombia.
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-background-300">
        <span className="text-xs font-medium tracking-wide uppercase">Scroll</span>
        <div className="w-5 h-8 rounded-full border-2 border-background-300 flex justify-center pt-1">
          <div className="w-1 h-2 rounded-full bg-background-300 animate-bounce" />
        </div>
      </div>
    </section>
  );
}